import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

const PORTAL_ID = "86d33b1f539843268de673825ebd47ec";

  export const countyLayer = new FeatureLayer({
    portalItem: {
      id: PORTAL_ID
    },
    // definitionExpression: `FIPSSTCO = '${county.GEOID}'`,
    renderer: {
      type: 'simple',
      symbol: {
        type: "simple-line",
        color: 'black',
        width: '2px',
      }
    }
  })
